import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthRedirect({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return; // Wait for auth to load

    const isAuthPage =
      location.pathname === '/login' ||
      location.pathname === '/signup' ||
      location.pathname === '/forgot-password' ||
      location.pathname === '/reset-password';
    const isPublicPage = location.pathname === '/' || 
                         location.pathname === '/terms' || 
                         location.pathname === '/feedback';

    if (user && isAuthPage) {
      const to = location.pathname === '/signup' ? '/activities' : '/dashboard'
      const id = window.setTimeout(() => {
        navigate(to, { replace: true, viewTransition: true })
      }, 420)
      return () => window.clearTimeout(id)
    } else if (!user && !isPublicPage && !isAuthPage) {
      // User is not logged in and trying to access protected pages
      navigate('/login', { replace: true });
    }
  }, [user, loading, location.pathname, navigate]);

  if (loading) {
    return (
      <div className="page-loading page-loading--screen" role="status" aria-live="polite">
        <span className="page-loading-spinner" aria-hidden />
      </div>
    );
  }

  return children;
}
